import styled, { css, DefaultTheme } from "styled-components";
import { theme } from "../../constants/StyledComponents";

type StyledTitlesTypProps = {
  $variant?: string;
  $color?: string;
};

/* variants */

const variantStyles = (theme: DefaultTheme, variant = "2") =>
  ({
    1: css`
      font-size: ${theme.variables.fs_26};
    `,
    2: css`
      font-size: ${theme.variables.fs_24};
    `,
    3: css`
      font-size: ${theme.variables.fs_18};
    `,
    4: css`
      font-size: ${theme.variables.fs_40};
    `,
    5: css`
      font-size: ${theme.variables.fs_28};
    `,
    6: css`
      font-size: ${theme.variables.fs_16};
    `,
  })[variant];

const StyledTitlesTyp = styled.span<StyledTitlesTypProps>`
  ${({ theme, $variant: variant }) => variantStyles(theme, variant)}
  color: ${({ $color: color }) => color ?? theme.colors.black};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export { StyledTitlesTyp };
